import React, { useEffect, useState } from "react";
import "../BudgetDetailReports.css";
import List from "../../styledComponents/Table/List";
import plaidIcon from "../../../assets/images/budget/plaidlogo.png";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Tab, { TabItem } from "../../Budget/BudgetComponents/SettingTabs/Tabs";
import moment from "moment";
import { BudgetReportList } from "./BudgetReportList";
export const AllBudgetReport = () => {
  const budgetReport = useSelector(
    (state) => state.rootReducer.loginUser.budgetReportData
  );
  console.log("budgetReport", budgetReport);
  const history = useHistory();
  const [budgetData, setBudgetData] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabSelected = (index) => {
    console.log(index);
    setSelectedIndex(index);
  };

  const categoryCols = [
    {
      title: "Category",
      dataIndex: "categoryFromPlaid",
      sorter: (a, b) =>
        (a.categoryFromPlaid || "").localeCompare(b.categoryFromPlaid || ""),
      render: (fileName, record) => {
        return record.categoryFromPlaid ? (
          <div>
            <div>{record.categoryFromPlaid}</div>
            {record.subCategory && (
              <span style={{ color: "black" }}>({record.subCategory})</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Total",
      dataIndex: "amount",
      sorter: (a, b) => {
        const amountA = parseFloat(a.amount);
        const amountB = parseFloat(b.amount);
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (fileName, record) => (
        <div
          style={{
            width: "100%",
            fontWeight: "bold",
            color:
              record.typeOfTransaction === "Expense" || record.amount < 0
                ? "#00A27B"
                : "",
          }}
        >
          {record.amount
            ? !isNaN(record.amount)
              ? `${
                  "$" +
                  (record.amount < 0
                    ? (record.amount * -1).toFixed(2) // Negative to positive
                    : (record.amount * -1).toFixed(2)
                  ) // Positive to negative
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }`
              : "N/A"
            : "N/A"}
        </div>
      ),
    },
  ];
  const cols = [
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => (a.date || "").localeCompare(b.date || ""),
      render: (record) =>
        record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },
    {
      title: "Item Name",
      dataIndex: "itemName",
      sorter: (a, b) => (a.itemName || "").localeCompare(b.itemName || ""),
      render: (fileName, record) => {
        return record.itemName ? (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <img
              style={{ borderRadius: "50%" }}
              height={34}
              width={34}
              src={record.itemLogo ? record.itemLogo : plaidIcon}
            ></img>
            <div>{record.itemName}</div>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Category",
      dataIndex: "categoryFromPlaid",
      sorter: (a, b) =>
        (a.categoryFromPlaid || "").localeCompare(b.categoryFromPlaid || ""),
      render: (fileName, record) => {
        return record.categoryFromPlaid ? (
          <div>
            <div>{record.categoryFromPlaid}</div>
            {record.subCategory && (
              <span style={{ color: "black" }}>({record.subCategory})</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => {
        const amountA = parseFloat(a.amount);
        const amountB = parseFloat(b.amount);
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (fileName, record) => (
        <div
          style={{
            width: "100%",
            fontWeight: "bold",
            color:
              record.typeOfTransaction === "Expense" || record.amount < 0
                ? "#00A27B"
                : "",
          }}
        >
          {record.amount
            ? !isNaN(record.amount)
              ? `${
                  "$" +
                  (record.amount < 0
                    ? (record.amount * -1).toFixed(2) // Negative to positive
                    : (record.amount * -1).toFixed(2)
                  ) // Positive to negative
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }`
              : "N/A"
            : "N/A"}
        </div>
      ),
    },
    {
      title: "Bank",
      dataIndex: "bankName",
      // sorter: (a, b) => a["bankName"] > b["bankName"],
      sorter: (a, b) => (a.bankName || "").localeCompare(b.bankName || ""),
      render: (fileName, record) => {
        return record.bankName ? (
          <div>
            <div>{record.bankName}</div>
            {record.accountType && (
              <span style={{ color: "black" }}>{record.accountType}</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Type of Transaction",
      dataIndex: "typeOfTransaction",
      sorter: (a, b) =>
        (a.typeOfTransaction || "").localeCompare(b.typeOfTransaction || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      sorter: (a, b) => (a.notes || "").localeCompare(b.notes || ""),
      render: (record) => (record ? record : "N/A"),
    },
  ];
  useEffect(() => {
    if (budgetReport === undefined || budgetReport === null) {
      history.push("/reports/budgetDetails");
    }
    if (budgetReport) {
      // Filter all transactions
      const allAccount = budgetReport;

      // Filter for checking and savings accounts with a non-null category
      const checkingSavingData = budgetReport.filter((item) => {
        return (
          (item.accountType === "checking" || item.accountType === "savings") &&
          item.categoryFromPlaid !== null
        );
      });

      // Filter for credit card accounts with a non-null category
      const creditData = budgetReport.filter((item) => {
        return (
          item.accountType === "credit card" && item.categoryFromPlaid !== null
        );
      });

      // Filter for investment accounts based on exclusion of other types, with a non-null category
      // const investmentData = budgetReport.filter((item) => {
      //   return (
      //     ![
      //       "checking",
      //       "savings",
      //       "credit card",
      //       "student",
      //       "loan",
      //       "auto",
      //       "business",
      //       "commercial",
      //       "construction",
      //       "consumer",
      //       "overdraft",
      //       "home equity",
      //       "line of credit",
      //       "mortgage",
      //     ].includes(item.accountType) && item.categoryFromPlaid !== null
      //   );
      // });

      // // Filter for student-related accounts and other specified account types with a non-null category
      // const studentData = budgetReport.filter((item) => {
      //   return (
      //     [
      //       "student",
      //       "mortgage",
      //       "loan",
      //       "auto",
      //       "business",
      //       "commercial",
      //       "construction",
      //       "consumer",
      //       "overdraft",
      //       "home equity",
      //       "line of credit",
      //     ].includes(item.accountType) && item.categoryFromPlaid !== null
      //   );
      // });

      // Filter transactions with a null category
      const nullCategoryDataNullCategory = budgetReport.filter((item) => {
        return item.categoryFromPlaid === null;
      });

      // Compile all filtered data into a result object
      const resultObject = {
        allAccount,
        checkingSavingData,
        creditData,
        nullCategoryDataNullCategory,
      };
      setBudgetData(resultObject);
    }
  }, []);
  const Tabs = [
    {
      id: 1,
      name: "All Accounts",
    },
    {
      id: 2,
      name: "Checking and Saving",
    },

    {
      id: 4,
      name: "Credit Cards",
    },

    {
      id: 6,
      name: "Uncategorized",
    },
  ];
  const sumAmountsByCategory = (transactions) => {
    const categorySums =
      transactions &&
      transactions.reduce((acc, transaction) => {
        const {
          categoryFromPlaid,
          subCategory,
          amount,
          accountName,
          bankName,
          accountNumber,
        } = transaction;
        const key = `${categoryFromPlaid}_${subCategory || ""}`;
        if (!acc[key]) {
          acc[key] = { categoryFromPlaid, subCategory, amount: 0 };
        }
        if (accountName && !acc[key].accountName) {
          acc[key].accountName = accountName;
        }

        if (bankName && !acc[key].bankName) {
          acc[key].bankName = bankName;
        }

        if (accountNumber && !acc[key].accountNumber) {
          acc[key].accountNumber = accountNumber;
        }
        acc[key].amount += amount;
        return acc;
      }, {});

    return Object.values(categorySums);
  };
  const getFilteredData = () => {
    if (!budgetReport && !budgetData) return [];

    switch (selectedIndex) {
      case 1:
        return budgetData.checkingSavingData;
      case 2:
        return budgetData.creditData;
      case 3:
        return budgetData.nullCategoryDataNullCategory;
      default:
        return budgetData.allAccount;
    }
  };
  const filteredReport = budgetData && getFilteredData();
  // console.log("filteredReport", filteredReport, budgetData);
  const categorySum = filteredReport
    ? sumAmountsByCategory(filteredReport)
    : [];
  return (
    <div className="BudgetReportMain1">
      <div className="TabSection">
        <Tab onTabSelected={onTabSelected}>
          {Tabs.map((tab, index) => (
            <TabItem key={tab.id}>{tab.name}</TabItem>
          ))}
        </Tab>
      </div>
      <BudgetReportList
        categorySum={categorySum && categorySum}
        filteredReport={filteredReport && filteredReport}
        tabName={selectedIndex}
      />
      {/* <div className="tableSection">
        <div className="leftTable">
          <div className="reportCardTitle">Category Data</div>
          <List cols={categoryCols} rows={categorySum && categorySum}></List>
        </div>
        <div className="rightTable">
          <div className="reportCardTitle">Transaction Data</div>
          <List cols={cols} rows={filteredReport && filteredReport}></List>
        </div>
      </div> */}
    </div>
  );
};
